<template>
  <div
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.container"
  >
    <template v-if="userWordmark">
      <LogoImagePrimary
        :useWordmark="true"
        :style="style.logoWordmark"
      />
    </template>
    <template v-else>
      <LogoImagePrimary
        :useWordmark="false"
        :style="style.logo"
      />
    </template>
    <div
      v-if="requireAuth"
      :style="style.right"
    >
      <div :style="style.row">
        <TextSmallPrimary
          :isNowrap="true"
          :style="style.text"
        >
          Logged in as
        </TextSmallPrimary>
        <TextEmailMutedSmallPrimary
          :truncate="true"
          :style="style.email"
        >
          {{ email }}
        </TextEmailMutedSmallPrimary>
      </div>
      <LinkMutedSmallPrimary @click.stop="logout">
        Log out
      </LinkMutedSmallPrimary>
    </div>
  </div>
</template>

<script>
  import LinkMutedSmallPrimary from '@modules/v2/link/link-muted-small-primary'
  import LogoImagePrimary from '@modules/v2/image/logo-image-primary'
  import TextEmailMutedSmallPrimary
    from '@modules/v2/text/text-email-muted-small-primary'
  import TextSmallPrimary from '@modules/v2/text/text-small-primary'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'TheHeaderMinimal',
    inheritAttrs: false,
    components: {
      LinkMutedSmallPrimary,
      LogoImagePrimary,
      TextEmailMutedSmallPrimary,
      TextSmallPrimary,
    },
    props: {
      requireAuth: {
        type: Boolean,
        requierd: false,
        default: false,
      },
    },
    data: function () {
      return {
        style: {
          container: {
            alignItems: 'center',
            boxSizing: 'border-box',
            display: 'flex',
            height: '64px',
            justifyContent: 'space-between',
            maxWidth: Layout.container.primary.maxWidth,
            padding: Layout.container.primary.padding,
            width: '100%',
          },
          email: {
            flex: 1,
          },
          logo: {
            height: '32px',
            minWidth: '32px',
          },
          logoWordmark: {
            height: '32px',
            minWidth: '160px',
            //width: '160px',
          },
          right: {
            alignItems: 'center',
            borderRadius: Layout.space.sm,
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            height: '50px',
            justifyContent: 'center',
            maxWidth: '200px',
            padding: Layout.space.sm,
            width: 'fit-content',
          },
          row: {
            alignItems: 'center',
            display: 'flex',
            width: '100%',
          },
          text: {
            margin: `0 ${Layout.space.xs} 0 0`,
          },
        },
      };
    },
    created: function () {
      Object.assign(
        this.style.right,
        {
          border: `solid ${this.color.dark5()}`,
          borderWidth: '1px',
        },
      );
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      ...mapState({
        email: state => state?.user?.email,
        windowWidth: state => state.window.width,
      }),
      userWordmark: function () {
        return parseInt(this.windowWidth) > 420;
      },
    },
    methods: {
      logout: function () {
        this.$store.commit('auth/clearRefreshToken');
      },
    },
  };
</script>
